<template>
    <connection-settings-popup
        :is-new="isNew"
        :config="{ dateField, offset }"
        :validations="$options.validations"
        :comment-id="commentId"
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_Delay_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_Delay_Delete_Body'),
            deleteButtonText: resource('JourneyComposer_JourneyBrickMenu_Delay_Button_DeleteCheckpoint')
        }"

        @save="save()"
        @delete="deleteCheckpoint()"
        @display-errors="displayErrors()"
        @hidden="$emit('hidden')"
    >
        <template #title>
            <h3>{{resource('JourneyBuilder_JourneyBrickMenu_Delay_DisplayName')}}</h3>
        </template>

        <template #body>
            <h4>{{resource("JourneyBuilder_JourneyBrick_SettingsHeader")}}</h4>
            <div>
                <div>
                    <label>{{resource('JourneyBuilder_FilterSettings_Offset_Column')}}</label>
                </div>

                <v-select
                    class='form-control mb-2'
                    placeholder="Applicable date field"
                    v-model="dateField"
                    :options="offsetDateColumns"
                    :disabled="!canWrite"
                />

                <time-period v-model="offset" showBeforeAfter :disabled="!canWrite" />
            </div>

            <error-message v-if="$v.$dirty && $v.$invalid" :message="resource('JourneyBuilder_Delay_DateFieldOrPeriodRequired_Message')" />

            <div>
                <div>
                    <label>{{resource('JourneyBuilder_Moment_WeekdayToSend')}}</label>
                </div>
                <v-select
                    class='form-control mb-2'
                    v-model="weekDay"
                    :options="daysOfTheWeek"
                    :clearable="false"
                    close-on-select
                    
                    :disabled="!canWrite"
                />
            </div>
        </template>
    </connection-settings-popup>
</template>

<script>
import api from "@modules/JourneyBuilder/api";
import VSelect from 'vue-select';
import resources from '@core/Util/Mixins/resources';
import TimePeriod from '@core/Components/Inputs/JiraStyleTimePeriod.vue';
import { NewComment } from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';
import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";
import {delayCheckpoint} from "@modules/JourneyBuilder/Bricks/checkpoint-definitions";
import {validationMixin} from 'vuelidate';
import {requiredUnless} from "vuelidate/lib/validators";
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
import ErrorMessage from '@core/Components/Errors/ErrorMessage';
import ConnectionSettingsPopup from '../ConnectionSettingsPopup';

export default {
    components: {
        TimePeriod,
        VSelect,
        NewComment,
        ErrorMessage,
        ConnectionSettingsPopup
    },
    
    mixins: [ resources, permissionsMixin, validationMixin ],

    props: {
        connection: Object,
        config: {
            type: Object
        },
        isNew: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        offsetDateColumns: [],

        dateField: null,
        offset: { seconds: 0, unit: "", weekDay: null },
        weekDay: null
    }),

    computed: {
        daysOfTheWeek() {
            return delayCheckpoint.daysOfTheWeek;
        },
        commentId() {
            return "connection:" + this.connection.id + ":" + delayCheckpoint.name;
        }
    },
    
    validations() {
        return {
            dateField: {
                required: requiredUnless(() => !!this.offset.seconds)
            },
            offset: {
                seconds: {
                    required: requiredUnless(() => !!this.dateField)
                }
            }
        }
    },
    
    created() {
        //Validations need to be explicitly bound to this component. We'll be passing them on to a child component with a different prop structure.
        this.$options.validations = this.$options.validations.bind(this);
        
        api.getTouchpointDelayDateColumns().then((columns) => {
            this.offsetDateColumns = columns.map((column) => {
                return {
                    label: column,
                    value: column
                }
            });

            if (this.config.offset) {
                this.dateField = this.offsetDateColumns.find(x => x.value === this.config.offset.dateField);
            }
        }, errorGrowl);
    },

    mounted() {
        if (this.config.offset) {
            this.offset = { 
                "seconds": this.config.offset.seconds, 
                "unit": this.config.offset.unit, 
            };
            this.weekDay = this.daysOfTheWeek.find(day => day.value == this.config.offset.weekDay)
        }
    },

    methods: {
        save() {
            const cfg = {
                offset: {
                    dateField: this.dateField && this.dateField.value,
                    seconds: this.offset.seconds,
                    unit: this.offset.unit,
                }
            };

            if (!isNaN(this.weekDay.value)) {
                cfg.offset.weekDay = this.weekDay.value;
            }
            
            this.$emit("save", cfg);
        },

        deleteCheckpoint() {
            this.$emit('delete-connection-checkpoint', { connection: this.connection, checkpoint: delayCheckpoint.name });
        },
        
        displayErrors(){
            this.$v.$touch();
        }
    },
}
</script>
